// @flow

import React from "react";
import { Grid, Card, Table, Page, StatsCard, Form, Button } from "tabler-react";
import "tabler-react/dist/Tabler.css";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
// import SiteWrapper from "../SiteWrapper.client.react";
import SiteWrapperSuperAdmin from "../SiteWrapper.superadmin.react";
import authActions from "../../redux/auth/action";
import clientService from "../../services/client";
import DownloadPopup, { FeedbackDownloadPopup } from "./downloadPopup";
import FeedBackAnalytics from "./FeedBackAnalytics";
import C3Chart from "react-c3js";
import "../../c3jscustom.css";
import "c3/c3.css";
import * as d3 from "d3";
import ReactWordcloud from "react-wordcloud";
import words from "./words";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "tippy.js/dist/tippy.css";
import "tippy.js/animations/scale.css";
const _ = require("lodash");
const moment = require("moment");

class Analytic extends React.Component {
  constructor(props) {
    let dd = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).setHours(0, 0, 0);
    let dd2 = new Date().setHours(23, 59, 59);
    let dataChart = {
      bindto: "#graph2",
      x: "x",
      columns: [["x"], ["Total Users"], ["Total Unique Users"]],
      colors: {
        "Total Users": "#0A49B6",
        "Total Unique Users": "#fd9644",
      },
    };
    super(props);
    this.state = {
      startDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
      endDate: new Date(),
      startDateBar: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
      endDateBar: new Date(),
      filterStartDate: new Date(
        Date.now() - 7 * 24 * 60 * 60 * 1000
      ).toLocaleDateString("en-US"),
      filterEndDate: new Date().toLocaleDateString("en-US"),
      filterStartDateBar: new Date(
        Date.now() - 7 * 24 * 60 * 60 * 1000
      ).toLocaleDateString("en-US"),
      filterEndDateBar: new Date().toLocaleDateString("en-US"),

      startDateSingleBar: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
      endDateSingleBar: new Date(),
      filterStartDateSingleBar: new Date(
        Date.now() - 7 * 24 * 60 * 60 * 1000
      ).toLocaleDateString("en-US"),
      filterEndDateSingleBar: new Date().toLocaleDateString("en-US"),

      startDateSingleBarHorizontal: new Date(
        Date.now() - 7 * 24 * 60 * 60 * 1000
      ),
      endDateSingleBarHorizontal: new Date(),
      filterStartDateSingleBarHorizontal: new Date(
        Date.now() - 7 * 24 * 60 * 60 * 1000
      ).toLocaleDateString("en-US"),
      filterEndDateSingleBarHorizontal: new Date().toLocaleDateString("en-US"),

      contextUniqueData: [],
      contextData: [],
      xAxisData: [],
      countDataUnique: [],
      countDataContext: [],
      sortValue: "",
      sortValueBar: "",
      userUniqueData: [],
      userData: [],
      userXAxisData: [],
      countDataUniqueUser: [],
      countDataUser: [],
      contextKey: [],
      dashboardData: "",
      openDownloadPopup: false,
      feedbackDownloadPopup: false,
      chartDataValue: dataChart,
      contextNameArr: [],
      graphStatus: true,
      allContextData: [],
      notificationContextData: [],
      allNotificationAiData: [],
      notificationAiData: [],
      notificationXAxix: [],
      contextKeyNotification: [],

      allNotificationAgentData: [],
      notificationAgentData: [],
      notificationAgentXAxix: [],
      avgCount: 0,

      //! for Agent Status  

      AgentStatusGraph: {
        columns: [
          ["x",],
          ['Total Chats',],
          // ['Total Chat Time',]
        ],
        type: 'bar',
        x: "x",
        colors: {
          "Total Chats": "#662C8F",
        },
      },
      startDateForAllChat: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
      endDateForAllChat: new Date(),
      chatAgent: "",
      arrayOfAgent: [],


      answerChatGraph: {
        x: "x",
        columns: [
          ["x"],
          ["Average"]
        ]
      },
      startDateForAnswerChatGraph: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
      endDateForAnswerChatGraph: new Date(),

      reportLogs: {
        columns: [
          ['Failure', 20],
          ['Success', 50],
        ],
        type: 'donut',
      },
      invoiceLogs: {
        columns: [
          ['Failure', 20],
          ['Success', 50],
        ],
        type: 'donut',
      },
      startDateForReportLogs: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
      endDateForReportLogs: new Date(),

      answerChatGraph: {
        x: "x",
        columns: [
          ["x"],
          ["Average (in min)"]
        ]
      },
      startDateForAnswerChatGraph: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
      endDateForAnswerChatGraph: new Date(),
      startDateForInvoiceLogs: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
      endDateForInvoiceLogs: new Date(),

    };
    this.closeDownloadPopup = this.closeDownloadPopup.bind(this);
  }

  closeDownloadPopup(data) {
    this.setState({
      openDownloadPopup: {
        open: false,
        data: false,
      },
    });
  }

  openDownloadPopup(e, data) {
    this.setState({
      openDownloadPopup: {
        open: true,
        data: data,
      },
    });
  }


  async getAnalyticsChatGraph(startDate, endDate) {
    await clientService.getAnalyticsChatGraph(startDate, endDate).then(res => {
      let data = {
        x: "x",
        columns: [
          ["x"],
          ['Average (in min)']
        ]
      };
      if (res.statusCode === 200 && res && res.data.length > 0) {
        console.log("<> mydata", res.data.map(m => `${((m.hour + 11) % 12 + 1)} ${m.hour >= 12 ? 'pm' : 'am'}`))
        console.log("<> mydata2", res.data.map(m => m.avg))
        let myData = res.data.filter(el => el.hour > 7 && 22 > el.hour)
        data = {
          x: "x",
          columns: [
            ["x", ...myData.map((m, i) => `${((m.hour + 11) % 12 + 1)} ${m.hour >= 12 ? 'pm' : 'am'}`)],
            ['Average (in min)', ...myData.map(m => parseFloat((m.avg / (1000 * 60)).toFixed(2)))]
          ]
        };
      }
      console.log("myData", data)
      this.setState({ answerChatGraph: data })
    })
  }
  async callServiceUnique(startDate, endDate) {
    if ((startDate != "" || startDate) && (endDate != "" || endDate)) {
      await clientService
        .getChartData(startDate, endDate, true, this.state.contextKey)
        .then(async (res) => {
          let data = res.data;
          data.forEach((d) => {
            d.dateObj = moment(d._id);
          });
          await this.setState({ contextUniqueData: data });
        })
        .catch((err) => console.error(err));

      await clientService
        .getChartData(startDate, endDate, false, this.state.contextKey)
        .then(async (res) => {
          let data = res.data;
          data.forEach((d) => {
            d.dateObj = moment(d._id);
          });
          await this.setState({ contextData: data });
        })
        .catch((err) => console.error(err));

      let contextUniqueData = await this.state.contextUniqueData;

      let contextData = await this.state.contextData;
      let xAxisData =
        (await contextUniqueData) && contextUniqueData.length > 0
          ? contextUniqueData.map((a) => a._id)
          : [];
      let countDataUnique =
        (await contextUniqueData) &&
        contextUniqueData.length > 0 &&
        contextUniqueData.map((a) => a.count);
      let countDataContext =
        (await contextData) &&
        contextData.length > 0 &&
        contextData.map((a) => a.count);

      await this.setState({ xAxisData, countDataUnique, countDataContext });
      await this.getDataLine();
    }
  }

  millisToMinutesAndSeconds(millis) {
    var minutes = Math.floor(millis / 60000);
    var seconds = ((millis % 60000) / 1000).toFixed(0);
    return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
  }

  buildData(data, keyName) {
    let result = [];
    _.forEach(data, (val, key) => {
      let totalCounts = val.reduce((acc, curr) => {
        return acc + curr.count;
      }, 0);
      console.log("keykey", key);
      result.push({ [keyName]: key, count: totalCounts });
    });
    return result;
  }

  groupAndBuild(data, dateMethod, groupKey) {
    let groupedData = _.groupBy(data, (d) => {
      return d.dateObj[dateMethod]();
    });
    console.log("groupedData", groupedData);
    return this.buildData(groupedData, groupKey);
  }

  componentDidMount() {
    clientService
      .getContext()
      .then((res) => {
        let notificationContextData = res.data.config.contexts
        .filter(
          (value) => {
            return (
              value.key === "book_test" ||
              value.key === "checkout_report" ||
              value.key === "checkout_invoice" 
            );
          }
        );

        this.setState({
          allContextData: res.data.config.contexts,
          notificationContextData,
        });
      })
      .catch((err) => console.error(err));

    console.log("filterStartDate", this.state.filterStartDate);
    document.title = "Voiceoc | Analytics";
    this.callServiceUnique(
      this.state.filterStartDate,
      this.state.filterEndDate
    );
    this.callServiceUniqueBar(
      this.state.filterStartDateBar,
      this.state.filterEndDateBar
    );
    clientService
      .getCountData()
      .then((res) => {
        this.setState({ dashboardData: res.data.data });
      })
      .catch((err) => console.error(err));
    this.callNotificationService(
      this.state.filterStartDateSingleBar,
      this.state.filterEndDateSingleBar,
      "ai"
    );
    this.callNotificationServiceAgent(
      this.state.filterStartDateSingleBar,
      this.state.filterEndDateSingleBar,
      "agent"
    );
    clientService
      .getAvgCst()
      .then((res) => {
        this.setState({
          avgCount: res.data.avgCst,
        });
      })
      .catch((err) => console.error(err));

    this.getLiveChatData();
    this.getAgentsChats(this.state.startDateForAllChat, this.state.endDateForAllChat, this.state.chatAgent);  //! Agent Status
    this.getAnalyticsChatGraph(this.state.startDateForAllChat, this.state.endDateForAllChat)  //! Live Chat  / time to answer
    this.getReportLogs(this.state.startDateForReportLogs, this.state.endDateForReportLogs); //* Done
    // this.getInvoiceLogs(new Date(), new Date());
    this.getInvoiceLogs(this.state.startDateForInvoiceLogs, this.state.endDateForInvoiceLogs); //* Done


  }

  //   ! All Chat

  ChangeDataForAllChat = async (e) => {
    e.preventDefault();
    // this.getAgentsChats(this.state.startDateForAllChat,this.state.endDateForAllChat,this.state.chatAgent);
    this.getAgentsChats(this.state.startDateForAllChat, this.state.endDateForAllChat);
  }

  async getInvoiceLogs(startDate, endDate) {
    var data = {
      columns: [
        ['Failure', 0],
        ['Success', 0],
      ],
      type: 'donut',
    }

    await clientService.getInvoiceLogs(startDate, endDate).then(res => {
      if (res.data.length > 0) {
        let col = res.data.map(m => ([m.status.charAt(0).toUpperCase() + m.status.slice(1), m.count]));
        data.columns = col;
      }
    }).catch(err => {
      console.log(err);
    })
    this.setState({ invoiceLogs: data })
  }

  async getAgentsChats(startDate, endDate) {
    // clientService.getAgentChats(startDate,endDate,agent).then(res=>{
    //     console.log(res);
    // })

    clientService.getAgentChats(startDate, endDate).then(res => {
      let chartData = {
        columns: [
          ["x", null],
          ['Total Chats', null],
          // ['Total Chat Time', null]
        ],
        colors: {
          "Total Chats": "#662C8F",
        },
        type: 'bar',
        x: "x"
      }
      if (res.data && res.data.result && res.data.result.length) {
        console.log(res.data.result);
        let col = [
          ["x", ...res.data.result.map(m => (m.name))],
          ['Total Chats', ...res.data.result.map(m => (m.totalChats))],
          // ['Total Chat Time', ...res.data.result.map(m => (m.totalChatTime))]
        ];

        chartData.columns = col;
      }
      this.setState({ AgentStatusGraph: chartData })
    })
  }
  async getAnalyticsChatGraph(startDate, endDate) {
    await clientService.getAnalyticsChatGraph(startDate, endDate).then(res => {
      let data = {
        x: "x",
        columns: [
          ["x"],
          ['Average']
        ]
      };
      if (res.statusCode === 200 && res && res.data.length > 0) {
        console.log("<> mydata", res.data.map(m => `${((m.hour + 11) % 12 + 1)} ${m.hour >= 12 ? 'pm' : 'am'}`))
        console.log("<> mydata2", res.data.map(m => `${typeof m.hour}`))
        let myData = res.data.filter(el => el.hour > 7 && 21 > el.hour)
        data = {
          x: "x",
          columns: [
            ["x", ...myData.map((m, i) => `${((m.hour + 11) % 12 + 1)} ${m.hour >= 12 ? 'pm' : 'am'}`)],
            ['Average', ...myData.map(m => Math.round(m.avg / (1000 * 60)))]
          ]
        };
      }
      this.setState({ answerChatGraph: data })
    })
  }
  DataChangeForAnswerChatGraph = async (e) => {
    e.preventDefault();
    this.getAnalyticsChatGraph(this.state.startDateForAnswerChatGraph, this.state.endDateForAnswerChatGraph)
  }

  async getLiveChatData() {
    clientService.getChartData(
      this.state.filterStartDateBar,
      new Date().toLocaleDateString("en-US"),
      false,
      "live_chat"
    )
      .then((res) => {
        console.log("~~~~~~~~~~>> ", res);
      });
  }

  async getReportLogs(startDate, endDate) {
    var data = {
      columns: [
        ['Failure', 0],
        ['Success', 0],
      ],
      type: 'donut',
    }

    await clientService.getReportLogs(startDate, endDate).then(res => {
      if (res.data.length > 0) {
        let col = res.data.map(m => ([m.status.charAt(0).toUpperCase() + m.status.slice(1), m.count]));
        data.columns = col;
      }
    }).catch(err => {
      console.log(err);
    })
    this.setState({ reportLogs: data })
  }

  exportData() {
    var url = process.env.REACT_APP_apiUrl + "bot/download-chats";
    window.open(url, "_blank");
  }

  getDataLine() {
    if (this.state.xAxisData.length) {
      let data = {
        bindto: "#graph2",
        // unload:true,
        x: "x",
        columns: [
          ["x", ...this.state.xAxisData],
          ["Total Users", ...this.state.countDataContext],
          ["Total Unique Users", ...this.state.countDataUnique],
        ],
        // unload: ['Total Users', 'Total Unique Users'],
        colors: {
          "Total Users": "#0A49B6",
          "Total Unique Users": "#fd9644",
        },
      };

      this.setState({
        chartDataValue: data,
      });
      // return data
    } else {
      let data = {
        bindto: "#graph2",
        x: "x",
        // unload:true,
        columns: [
          ["x", null],
          ["Total Users", null],
          ["Total Unique Users", null],
        ],
        colors: {
          "Total Users": "#0A49B6",
          "Total Unique Users": "#fd9644",
        },
      };

      this.setState({
        chartDataValue: data,
      });
      // return data
    }
  }

  getAxisLine() {
    let axis = {
      x: {
        type: "category",
        tick: {
          // precision: 0,
          beginAtZero: true,
          // rotate: 75,
          rotate: 75,
          multiline: false,
        },
        height: 130,
        unload: true,
      },
      y: {
        tick: {
          format: function (d) {
            return parseInt(d) == d ? d : null;
          },
          // precision: 0,
          // beginAtZero: true,
        },
        // show: true,
        unload: true,
      },
    };
    return axis;
  }

  getTimeToAnswerAxis() {
    let axis = {
      x: {
        type: "category",
        tick: {
          // precision: 0,
          beginAtZero: true,
          // rotate: 75,
          // rotate: 75,
          multiline: false,
        },
        height: 130,
        unload: true,
      },
      y: {
        tick: {
          beginAtZero: true,
          // precision: 0,
          // beginAtZero: true,
        },
        // show: true,
        unload: true,
      },
    };
    return axis;
    return axis;
  }
  getAxisLineBar() {
    let axis = {
      x: {
        type: "category",
        tick: {
          // rotate: 75,
          multiline: false,
        },
        height: 130,
      },
    };
    return axis;
  }
  getDataBar() {
    console.log("userXAxisData9999", this.state.userXAxisData);
    // console.log('userXAxisData', this.state.userXAxisData, 'getDataBar0', this.state.countDataUser, 'getDataBar1', ...this.state.countDataUniqueUser);
    if (this.state.userXAxisData.length > 0) {
      let data = {
        bindto: "#graph1",
        x: "x",
        columns: [
          ["x", ...this.state.userXAxisData],
          ["Total Users", ...this.state.countDataUser],
          ["Total Unique Users", ...this.state.countDataUniqueUser],
        ],
        type: "bar",
        colors: {
          "Total Users": "#662C8F",
          "Total Unique Users": "#EC4697",
        },
        // ['Total Users', 'Total Unique Users']
        // groups: [
        //     ['download', 'uploading']
        // ],
      };

      return data;
    } else {
      let data = {
        bindto: "#graph1",
        x: "x",
        columns: [
          // ['x', "Appointment Request", "Locate Clinic", "Callback Request"],
          ["x"],
          ["Total Users"],
          ["Total Unique Users"],
        ],
        type: "bar",
        // colors: {
        //     'Total Users': '#662C8F',
        //     "Total Unique Users": '#EC4697'

        // },
      };
      return data;
    }
  }

  getBar() {
    let bar = {
      width: {
        ratio: 0.5, // this makes bar width 50% of length between ticks
      },
    };
    return bar;
  }
  getAxisBar() {
    let axis = {
      x: {
        type: "category",

        // tick: {
        //     format: '%Y-%m-%d'
        // }
      },
    };

    return axis;
  }

  getDataSingleBar() {
    console.log("this.state.notificationXAxix", this.state.notificationXAxix);
    console.log("this.state.notificationXAxix", this.state.notificationAiData);
    if (this.state.notificationXAxix.length > 0) {
      let data = {
        bindto: "#graph3",
        x: "x",
        columns: [
          // ['x', ...this.state.userXAxisData],
          ["x", ...this.state.notificationXAxix],
          ["Total Users", ...this.state.notificationAiData],
        ],
        type: "bar",
        colors: {
          "Total Users": "#43702f",
        },
        // ['Total Users', 'Total Unique Users']
        // groups: [
        //     ['download', 'uploading']
        // ],
      };

      return data;
    } else {
      let data = {
        bindto: "#graph3",
        x: "x",
        columns: [
          // ['x', "Appointment Request", "Locate Clinic", "Callback Request"],
          ["x", null],
          ["Total Users", null],
        ],
        type: "bar",
        // colors: {
        //     'Total Users': '#662C8F',
        //     "Total Unique Users": '#EC4697'

        // },
      };
      return data;
    }
  }
  async sortGraph(value) {
    // debugger
    if (value) {
      await this.setState({ sortValue: value });
    }
    console.log("sortValuesortValue", this.state.sortValue);
    if (
      this.state.sortValue === "byWeek" &&
      this.state.contextUniqueData.length > 0 &&
      this.state.contextData.length > 0
    ) {
      let contextUniqueData = this.groupAndBuild(
        this.state.contextUniqueData,
        "week",
        "week"
      );
      let contextData = this.groupAndBuild(
        this.state.contextData,
        "week",
        "week"
      );
      let newData = contextUniqueData.map((el) => {
        if (el.week) return Object.assign({}, el, { week: "week-" + el.week });
        return el;
      });

      let xAxisData = [];
      let countDataUnique = [];
      let countDataContext = [];
      xAxisData = newData && newData.length > 0 && newData.map((a) => a.week);
      countDataUnique =
        newData && newData.length > 0 && newData.map((a) => a.count);
      countDataContext =
        contextData &&
        contextData.length > 0 &&
        contextData.map((a) => a.count);

      await this.setState({ xAxisData, countDataUnique, countDataContext });
      await this.getDataLine();
    } else if (
      this.state.sortValue === "byMonth" &&
      this.state.contextUniqueData.length > 0 &&
      this.state.contextData.length > 0
    ) {
      console.log("sortGraph240");
      let contextUniqueData = this.groupAndBuild(
        this.state.contextUniqueData,
        "month",
        "month"
      );
      let contextData = this.groupAndBuild(
        this.state.contextData,
        "month",
        "month"
      );
      let newData = contextUniqueData.map((el) => {
        if (el.month)
          return Object.assign({}, el, {
            month: "month-" + (parseInt(el.month) + 1),
          });
        return el;
      });
      let xAxisData =
        newData && newData.length > 0 && newData.map((a) => a.month);
      let countDataUnique =
        newData && newData.length > 0 && newData.map((a) => a.count);
      let countDataContext =
        contextData &&
        contextData.length > 0 &&
        contextData.map((a) => a.count);
      await this.setState({ xAxisData, countDataUnique, countDataContext });
      await this.getDataLine();
    } else {
      console.log("sortGraph253");
      this.callServiceUnique(
        this.state.filterStartDate,
        this.state.filterEndDate
      );
    }
  }
  handleChange(type, date) {
    console.log("datedate", date);
    let changeDate = new Date(date).toLocaleDateString("en-US");
    console.log("datedatechangeDate", changeDate);
    this.setState({ graphStatus: true });
    this.setState({
      [type]: date,
    });
    if (type === "startDate") {
      this.setState({ filterStartDate: changeDate });
    } else {
      this.setState({ filterEndDate: changeDate });
    }
  }

  submitData() { }

  async multiselect(data) {
    // debugger
    let checkData = this.state.contextKey.indexOf(data);
    if (checkData < 0) {
      await this.setState({ contextKey: this.state.contextKey.concat(data) });
      await this.callServiceUnique(
        this.state.filterStartDate,
        this.state.filterEndDate
      );
      await this.setState({ sortValue: "byDay" });
      await this.getDataLine();
    } else {
      const array = await this.state.contextKey;
      const index = await array.indexOf(data);
      if (index > -1) {
        await array.splice(index, 1);
        console.log("newListinside", array);
      }

      console.log("newList", array);
      let filtered = await array.filter(function (el) {
        return el != null;
      });
      console.log("newList--", filtered);
      await this.setState({ contextKey: filtered });
      await this.callServiceUnique(
        this.state.filterStartDate,
        this.state.filterEndDate
      );
      await this.setState({ sortValue: "byDay" });
      await this.getDataLine();
    }
  }
  handleSubmit = async (event) => {
    event.preventDefault();
    // this.callService(this.state.filterStartDate, this.state.filterEndDate)
    this.setState({ sortValue: "byDay" });
    this.callServiceUnique(
      this.state.filterStartDate,
      this.state.filterEndDate
    );
  };

  exportData() {
    var url = process.env.REACT_APP_apiUrl + "bot/download-chats";
    window.open(url, "_blank");
  }

  async callServiceUniqueBar(startDate, endDate) {
    await clientService
      .getChartUserData(startDate, endDate, true)
      .then(async (res) => {
        let data = res.data;
        await this.setState({ userUniqueData: data });
      })
      .catch((err) => console.error(err));

    await clientService
      .getChartUserData(startDate, endDate, false)
      .then(async (res) => {
        let data = res.data;
        await this.setState({ userData: data });
      })
      .catch((err) => console.error(err));
    let userUniqueData = this.state.userUniqueData;
    let userData = this.state.userData;

    let userXAxisData =
      userUniqueData &&
      userUniqueData.length > 0 &&
      userUniqueData.map((a) => a.contextName);
    let countDataUniqueUser =
      userUniqueData &&
      userUniqueData.length > 0 &&
      userUniqueData.map((a) => a.count);
    let countDataUser =
      userData && userData.length > 0 && userData.map((a) => a.count);
    this.setState({ userXAxisData, countDataUniqueUser, countDataUser });
  }

  sortGraphBar(e) {
    this.setState({ sortValueBar: e.target.value });
    if (
      e.target.value === "byWeek" &&
      this.state.userUniqueData.length > 0 &&
      this.state.userData.length > 0
    ) {
      let userUniqueData = this.groupAndBuild(
        this.state.userUniqueData,
        "week",
        "week"
      );
      let userData = this.groupAndBuild(this.state.userData, "week", "week");
      let newData = userUniqueData.map((el) => {
        if (el.week) return Object.assign({}, el, { week: "week-" + el.week });
        return el;
      });

      let userXAxisData = [];
      let countDataUniqueUser = [];
      let countDataUser = [];
      userXAxisData =
        newData && newData.length > 0 && newData.map((a) => a.week);
      countDataUniqueUser =
        newData && newData.length > 0 && newData.map((a) => a.count);
      countDataUser =
        userData && userData.length > 0 && userData.map((a) => a.count);

      this.setState({ userXAxisData, countDataUniqueUser, countDataUser });
    } else if (
      e.target.value === "byMonth" &&
      this.state.userUniqueData.length > 0 &&
      this.state.userData.length > 0
    ) {
      let userUniqueData = this.groupAndBuild(
        this.state.userUniqueData,
        "month",
        "month"
      );
      let userData = this.groupAndBuild(this.state.userData, "month", "month");
      let newData = userUniqueData.map((el) => {
        if (el.month)
          return Object.assign({}, el, { month: "month-" + el.month });
        return el;
      });
      let userXAxisData =
        newData && newData.length > 0 && newData.map((a) => a.month);
      let countDataUniqueUser =
        newData && newData.length > 0 && newData.map((a) => a.count);
      let countDataUser =
        userData && userData.length > 0 && userData.map((a) => a.count);
      this.setState({ userXAxisData, countDataUniqueUser, countDataUser });
    } else {
      this.callServiceUniqueBar(
        this.state.filterStartDateBar,
        this.state.filterEndDateBar
      );
    }
  }

  handleChangeBar(type, date) {
    console.log("datedate", date);
    // debugger
    let changeDate = new Date(date).toLocaleDateString("en-US");
    // console.log('datedate---',changeDate)

    this.setState({ graphStatus: false });
    this.setState({
      [type]: date,
    });
    if (type === "startDateBar") {
      this.setState({ filterStartDateBar: changeDate });
    } else {
      this.setState({ filterEndDateBar: changeDate });
    }
  }

  handleSubmitBar = async (event) => {
    event.preventDefault();
    // this.callService(this.state.filterStartDate, this.state.filterEndDate)
    this.setState({ sortValue: "byDay" });
    this.callServiceUniqueBar(
      this.state.filterStartDateBar,
      this.state.filterEndDateBar
    );
  };

  handleChangeSingleBar(type, date) {
    console.log("datedate", date);
    // debugger
    let changeDate = new Date(date).toLocaleDateString("en-US");
    // console.log('datedate---',changeDate)

    // this.setState({graphStatus:false})
    this.setState({
      [type]: date,
    });
    if (type === "startDateSingleBar") {
      this.setState({ filterStartDateSingleBar: changeDate });
    } else {
      this.setState({ filterEndDateSingleBar: changeDate });
    }
  }

  async callNotificationService(startDate, endDate, type, context) {
    await clientService
      .getfeedBack(startDate, endDate, type, context)
      .then((res) => {
        // console.log('resresres---',res.data)
        let data = res.data;
        let arrRating = [];
        let rating = [1, 2, 3, 4, 5];
        rating.forEach((item) => {
          console.log("itemitem", item);
          let rating1 = data.find((x) => x.rating == item);

          if (rating1) {
            arrRating.push(rating1);
          } else {
            arrRating.push({ rating: item, count: 0 });
          }
        });
        console.log("arrRatingarrRating", arrRating);
        this.setState({
          allNotificationAiData: arrRating,
        });
      })
      .catch((err) => console.error(err));

    let allData = this.state.allNotificationAiData;
    let notificationAiData =
      allData && allData.length > 0 && allData.map((a) => a.count);
    let notificationXAxix =
      allData && allData.length > 0 && allData.map((a) => a.rating);
    this.setState({ notificationAiData, notificationXAxix });
    await this.getDataSingleBar();
  }

  async callNotificationServiceAgent(startDate, endDate, type) {
    await clientService
      .getfeedBack(startDate, endDate, type)
      .then((res) => {
        console.log("res.data`````````````````````````````````````````````,", res.data);
        this.setState({
          allNotificationAgentData: res.data,
        });
      })
      .catch((err) => console.error(err));

    // let allData = this.state.allNotificationAgentData;
    // let notificationAgentData = allData && allData.length > 0 && allData.map(a => a.name);
    // let notificationAgentXAxix = allData && allData.length > 0 && allData.map(a => a.averageQuantity);
    // this.setState({notificationAgentData,notificationAgentXAxix})
    // await this.getDataSingleBarHorizontal()
  }
  handleSubmitSingleBar = async (event) => {
    event.preventDefault();

    this.callNotificationService(
      this.state.filterStartDateSingleBar,
      this.state.filterEndDateSingleBar,
      "ai",
      this.state.contextKeyNotification
    );
  };


  openFeedbackDownloadPopup() {
    this.setState({
      feedbackDownloadPopup: {
        open: true,
        data: false,
      }
    })
  }
  closeFeedbackDownloadPopup() {
    this.setState({
      feedbackDownloadPopup: {
        open: false,
        data: false
      }
    })
  }
  async multiselectSingle(data) {
    // debugger
    let checkData = this.state.contextKeyNotification.indexOf(data);
    if (checkData < 0) {
      await this.setState({
        contextKeyNotification: this.state.contextKeyNotification.concat(data),
      });
      await this.callNotificationService(
        this.state.filterStartDateSingleBar,
        this.state.filterEndDateSingleBar,
        "ai",
        this.state.contextKeyNotification
      );
      // await this.setState({ sortValue: 'byDay' })
      // await this.getDataLine();
    } else {
      const array = await this.state.contextKeyNotification;
      const index = await array.indexOf(data);
      if (index > -1) {
        await array.splice(index, 1);
      }

      let filtered = await array.filter(function (el) {
        return el != null;
      });
      await this.setState({ contextKeyNotification: filtered });
      await this.callNotificationService(
        this.state.filterStartDateSingleBar,
        this.state.filterEndDateSingleBar,
        "ai",
        this.state.contextKeyNotification
      );
      await this.getDataSingleBar();
      // await this.setState({ sortValue: 'byDay' })
      // await this.getDataLine();
    }
  }

  finalLineGraph(chartDataValue) {
    return (
      <C3Chart
        data={this.state.chartDataValue}
        size={{
          height: 340,
        }}
        transition={{
          duration: 1000,
        }}
        // size={{
        //   height: 340,
        //   //  width:240
        // }}
        axis={this.getAxisLine()}
        padding={{
          bottom: 0,
          top: 0,
        }}
      />
    );

    // }
  }

  componentWillReceiveProps() {
    this.finalLineGraph();
  }
  componentDidUpdate() {
    this.finalLineGraph();
  }

  getDataSingleBarHorizontal() {
    // console.log('this.state.notificationAgentXAxix',this.state.notificationAgentData)
    if (this.state.allNotificationAgentData.length > 0) {
      let data = {
        bindto: "#graph3",
        x: "x",
        columns: [
          ["x", ...this.state.allNotificationAgentData.map((el) => el.name)],
          [
            "Average Rating",
            ...this.state.allNotificationAgentData.map((el) => el.averageQuantity),
          ],
          // [
          //   "Not Good",
          //   ...this.state.allNotificationAgentData.map((el) => el.NotGoodCount),
          // ],
        ],
        type: "bar",
        // colors: {
        //   Good: "#EC4697",
        //   // "Not Good": "#f4c430",
        // },
      };

      return data;
    } else {
      let data = {
        bindto: "#graph3",
        x: "x",
        columns: [
          ["x", null],
          ["Average Rating", null],
          // ["Not Good", null],
        ],
        type: "bar",
        // colors: {
        //   Good: "#EC4697",
        //   // "Not Good": "#f4c430",
        // },
      };
      return data;
    }
  }
  handleSubmitSingleBarHorizontal = async (event) => {
    event.preventDefault();

    this.callNotificationServiceAgent(
      this.state.filterStartDateSingleBarHorizontal,
      this.state.filterEndDateSingleBarHorizontal,
      "agent"
    );
    this.getDataSingleBarHorizontal();
  };

  DataChangeReport = async (e) => {
    e.preventDefault();
    this.getReportLogs(this.state.startDateForReportLogs, this.state.endDateForReportLogs);
  }

  DataChangeInvoice = async (e) => {
    e.preventDefault();
    this.getInvoiceLogs(this.state.startDateForInvoiceLogs, this.state.endDateForInvoiceLogs);
  }

  handleChangeBarHorizontal(type, date) {
    console.log("datedate", date);
    // debugger
    let changeDate = new Date(date).toLocaleDateString("en-US");
    // console.log('datedate---',changeDate)

    // this.setState({graphStatus:false})
    this.setState({
      [type]: date,
    });
    if (type === "startDateSingleBarHorizontal") {
      this.setState({ filterStartDateSingleBarHorizontal: changeDate });
    } else {
      this.setState({ filterEndDateSingleBarHorizontal: changeDate });
    }
  }

  DataChangeForAnswerChatGraph = async (e) => {
    e.preventDefault();
    this.getAnalyticsChatGraph(this.state.startDateForAnswerChatGraph, this.state.endDateForAnswerChatGraph)
  }
  handlerAllChatDateChanger(type, event) {
    if (type === 'endDateAllChat') {
      this.setState({ endDateForAllChat: event })
    }
    if (type === 'startDateAllChat') {
      this.setState({ startDateForAllChat: event })
    }
    if (type === "startDateAnswerChatGraph") {
      this.setState({ startDateForAnswerChatGraph: event })
    }
    if (type === "endDateAnswerChatGraph") {
      this.setState({ endDateForAnswerChatGraph: event })
    }
    if (type === "startDateForReportLogs") {
      this.setState({ startDateForReportLogs: event })
    }
    if (type === "endDateForReportLogs") {
      this.setState({ endDateForReportLogs: event })
    }
    if (type === "startDateForInvoiceLogs") {
      this.setState({ startDateForInvoiceLogs: event })
    }
    if (type === "endDateForInvoiceLogs") {
      this.setState({ endDateForInvoiceLogs: event })
    }
  }
  changeAgentChat(e) {
    console.log(e.target.value);
    this.setState({ chatAgent: e.target.value })
  }


  tooltip_contentsForReportLogs(d, defaultTitleFormat, defaultValueFormat, color) {
    // console.log(d,defaultTitleFormat,defaultTitleFormat,color);
    var $$ = this, config = $$.config, CLASS = $$.CLASS,
      titleFormat = config.tooltip_format_title || defaultTitleFormat,
      nameFormat = config.tooltip_format_name || function (name) { return name; },
      valueFormat = config.tooltip_format_value || defaultValueFormat,
      text, i, title, value, name, bgcolor;

    for (i = 0; i < d.length; i++) {
      if (!(d[i] && (d[i].value || d[i].value === 0))) { continue; }

      // ADD
      if (d[i].name === 'data2') { continue; }


      if (!text) {
        title = 'MY TOOLTIP'
        text = "<table class='" + CLASS.tooltip + "'>" + (title || title === 0 ? "<tr><th colspan='2'>" + d[i].name + "</th></tr>" : "");
      }
      name = nameFormat(d[i].name);
      value = valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index);
      bgcolor = $$.levelColor ? $$.levelColor(d[i].value) : color(d[i].id);

      text += "<tr class='" + CLASS.tooltipName + "-" + d[i].id + "'>";
      text += "<td class='name'><span style='background-color:" + bgcolor + "'></span>" + "Percentage" + "</td>";
      text += "<td class='value'>" + value + "</td>";
      text += "</tr>";

      text += "<tr class='" + CLASS.tooltipName + "-" + d[i].id + "'>";
      text += "<td class='name'><span style='background-color:" + bgcolor + "'></span>" + "Count" + "</td>";
      text += "<td class='value'>" + d[i].value + "</td>";
      text += "</tr>";
    }
    return text + "</table>";
  }

  tooltip_contentsForInvoiceLogs(d, defaultTitleFormat, defaultValueFormat, color) {
    // console.log(d,defaultTitleFormat,defaultTitleFormat,color);
    var $$ = this, config = $$.config, CLASS = $$.CLASS,
      titleFormat = config.tooltip_format_title || defaultTitleFormat,
      nameFormat = config.tooltip_format_name || function (name) { return name; },
      valueFormat = config.tooltip_format_value || defaultValueFormat,
      text, i, title, value, name, bgcolor;

    for (i = 0; i < d.length; i++) {
      if (!(d[i] && (d[i].value || d[i].value === 0))) { continue; }

      // ADD
      if (d[i].name === 'data2') { continue; }


      if (!text) {
        title = 'MY TOOLTIP'
        text = "<table class='" + CLASS.tooltip + "'>" + (title || title === 0 ? "<tr><th colspan='2'>" + d[i].name + "</th></tr>" : "");
      }
      name = nameFormat(d[i].name);
      value = valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index);
      bgcolor = $$.levelColor ? $$.levelColor(d[i].value) : color(d[i].id);

      text += "<tr class='" + CLASS.tooltipName + "-" + d[i].id + "'>";
      text += "<td class='name'><span style='background-color:" + bgcolor + "'></span>" + "Percentage" + "</td>";
      text += "<td class='value'>" + value + "</td>";
      text += "</tr>";

      text += "<tr class='" + CLASS.tooltipName + "-" + d[i].id + "'>";
      text += "<td class='name'><span style='background-color:" + bgcolor + "'></span>" + "Count" + "</td>";
      text += "<td class='value'>" + d[i].value + "</td>";
      text += "</tr>";
    }
    return text + "</table>";
  }

  render() {
    const { dashboardData } = this.state;
    return (
      <SiteWrapperSuperAdmin>
        <Page.Content>
          <div className="row">
            <Card.Title className="col col-6 col-sm-6 col-lg-8">
              Analytics
            </Card.Title>

            <div className="col-6 col-sm-6 col-lg-4 text-right" >
              {/* <div style={{ height: 400, width: 600 }}>
      <ReactWordcloud words={words} />
    </div> */}
              {/* <Link
                              to="#"
                              title={changeLanguage(this.props.siteLanguage, 'click_to_download_chat')}
                              onClick={(e) => this.openDownloadPopup(e, client._id)}>
                              <Icon prefix="fa" name="download"></Icon>
                            </Link> */}

              <Button
                color="primary btn "
                className=" aligncentre"
                type="button"
                onClick={(e) => this.openDownloadPopup()}
              >
                Download
              </Button>
              <Button color="primary btn "
                className=" aligncentre"
                type="button"
                onClick={(e) => this.openFeedbackDownloadPopup()}
              >Download Feedback Data</Button>
            </div>
          </div>

          <div className="clearfix"></div>
          <Grid.Row>
            <Grid.Col>
              <div className="box_flex_container">
                <div className="box1_flex">
                  <div className="card card101">
                    <div className="card-body  text-center">
                      <StatsCard
                        layout={1}
                        movement={dashboardData.allUsersPercentageChange}
                        total={dashboardData.todayUsers}
                        label="Total Users"
                      />
                    </div>
                  </div>
                </div>

                <div className="box1_flex">
                  <div className="card card101">
                    <div className="card-body  text-center">
                      <StatsCard
                        layout={1}
                        // movement={dashboardData.todayUniqueUsers}
                        movement={dashboardData.uniqueUsersPercentageChange}
                        total={dashboardData.todayUniqueUsers}
                        label="Total Unique Users"
                      />
                    </div>
                  </div>
                </div>

                <div className="box1_flex">
                  <div className="card card101">
                    <div className="card-body p-3 text-center">
                      <StatsCard
                        layout={1}
                        movement={dashboardData.completedFlowPercentageChange}
                        total={dashboardData.todayCompletedFlow}
                        label="Completed Flows"
                      />
                    </div>
                  </div>
                </div>

                <div className="box1_flex">
                  <div className="card card101">
                    <div className="card-body p-3 text-center">
                      <StatsCard
                        layout={1}
                        movement={dashboardData.inCompletedFlowPercentageChange}
                        total={dashboardData.todayInCompletedFlow}
                        label="Incomplete Flows"
                      />
                    </div>
                  </div>
                </div>

                <div className="box1_flex">
                  <div className="card card101">
                    <div className="card-body p-3 text-center hide_movement">

                      {/* <StatsCard 
                        layout={1}
                        movement={dashboardData.sessionTimePercentageChange} 
                        total={`${this.state.avgCount.toFixed(2)} %`} 
                        label="CSAT" /> */}
                      <StatsCard layout={1}
                        movement={""}
                        total={`${this.state.avgCount.toFixed(2)} %`} label="CSAT" />

                    </div>
                  </div>
                </div>

              </div>
            </Grid.Col>
          </Grid.Row>
          <Grid.Row>

            {/* <div className="col col-sm-6">  
                        <Card>
                            <Card.Header>
                                <Card.Title>Analytics</Card.Title>

                            </Card.Header>
                            <StatsCard layout={1} movement={-3} total="17" label="Closed Today" />
                            <StatsCard layout={1} movement={+4} total="17" label="Closed Today" />

                        </Card>

                        </div> */}

            <div className="box-al">
              <form onSubmit={this.handleSubmit}>
                <div className="row">
                  <div className="col col-sm-5 ">
                    <label className="form-label">From Date</label>
                    <DatePicker
                      className="form-control"
                      selected={this.state.startDate}
                      onChange={(e) => this.handleChange("startDate", e)}
                      maxDate={this.state.endDate}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="DD/MM/YYYY"
                      maxDate={new Date()}
                    />
                  </div>

                  <div className="col col-6 col-sm-5 ">
                    <label className="form-label">To Date</label>
                    <DatePicker
                      className="form-control"
                      selected={this.state.endDate}
                      onChange={(e) => this.handleChange("endDate", e)}
                      maxDate={new Date()}
                      minDate={this.state.startDate}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="DD/MM/YYYY"
                    />
                  </div>
                  <div className="col col-6 col-sm-2 ">
                    <br />
                    <Button color="primary   sub1" type="submit">
                      Submit
                    </Button>
                  </div>
                </div>
              </form>
            </div>

            <div className="col col-12 col-sm-12 col-lg-12">
              <div className="card card101">
                <div className="row">
                  <div className=" pull-left col col-12 col-sm-12 col-lg-7 ">
                    <h3 className="card-title">Traffic Analysis</h3>
                  </div>

                  <div className=" col col-12 col-sm-12 col-lg-5">
                    {this.state.allContextData &&
                      this.state.allContextData.length > 0 && (
                        <Form.Group label="Service" className="pull-right">
                          <Form.SelectGroup canSelectMultiple pills>
                            {this.state.allContextData.map((val, index) => {
                              return (
                                <Form.SelectGroupItem
                                  label={val.value}
                                  name={val.key}
                                  value="HTML"
                                  onClick={(e) => this.multiselect(val.key)}
                                />
                              );
                            })}
                          </Form.SelectGroup>
                        </Form.Group>
                      )}
                  </div>
                </div>

                <div className="card-body p-3 text-center">
                  {this.finalLineGraph()}
                </div>

                <div>
                  <div className="sortvalue drop-1">
                    <select
                      className="form-control custom-select auto1"
                      onChange={(e) => this.sortGraph(e.target.value)}
                      value={this.state.sortValue}
                    >
                      <option value="byDay">By Day</option>
                      <option value="byWeek">By Week</option>
                      <option value="byMonth">By Month</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div className="box-al mar-40">
              <form onSubmit={this.handleSubmitBar}>
                <div className="row">
                  <div className="col col-6 col-sm-4 col-lg-5">
                    <label className="form-label">From Date</label>
                    <DatePicker
                      className="form-control"
                      selected={this.state.startDateBar}
                      onChange={(e) => this.handleChangeBar("startDateBar", e)}
                      maxDate={this.state.endDateBar}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="DD/MM/YYYY"
                      maxDate={new Date()}
                    />
                  </div>

                  <div className="col col-6 col-sm-4 col-lg-5">
                    <label className="form-label">To Date</label>
                    <DatePicker
                      className="form-control"
                      selected={this.state.endDateBar}
                      onChange={(e) => this.handleChangeBar("endDateBar", e)}
                      maxDate={new Date()}
                      minDate={this.state.startDateBar}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="DD/MM/YYYY"
                    />
                  </div>

                  <div className="col col-6 col-sm-4 col-lg-2">
                    <br />
                    <Button color="primary   sub1" type="submit">
                      Submit
                    </Button>
                  </div>
                </div>
              </form>
            </div>

            <div className="col col-12 col-sm-12 col-lg-12">
              <div className="card card101">
                <div className="row">
                  <div className=" pull-left col col-12 col-sm-12 col-lg-12">
                    <h3 className="card-title">Service Breakdown</h3>
                  </div>
                </div>

                <div className="card-body p-3 text-center">
                  <C3Chart
                    data={this.getDataBar()}
                    size={{
                      height: 440,
                    }}
                    bar={{
                      width: 50,
                    }}
                    axis={this.getAxisLineBar()}
                    padding={{
                      bottom: 0,
                      top: 0,
                    }}
                  />
                </div>
                {/* 
                                <div>
                                    <div className="sortvalue drop-1">
                                        <select className="form-control custom-select auto1"
                                            onChange={(e) => this.sortGraphBar(e)} value={this.state.sortValueBar}>
                                            <option value="byDay">
                                                By Day
                                    </option>
                                            <option value="byWeek">
                                                By Week
                                    </option>
                                            <option value="byMonth">
                                                By Month
                                    </option>

                                        </select>
                                    </div>
                                </div> */}
              </div>
            </div>

            <div className="box-al mar-40">
              <form onSubmit={this.handleSubmitSingleBar}>
                <div className="row">
                  <div className="col col-6 col-sm-4 col-lg-5">
                    <label className="form-label">From Date</label>
                    <DatePicker className="form-control"
                      selected={this.state.startDateSingleBar}
                      onChange={(e) => this.handleChangeSingleBar('startDateSingleBar', e)}
                      maxDate={this.state.endDateSingleBar}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="DD/MM/YYYY"
                      maxDate={new Date()}
                    />
                  </div>

                  <div className="col col-6 col-sm-4 col-lg-5">
                    <label className="form-label">To Date</label>
                    <DatePicker className="form-control"
                      selected={this.state.endDateSingleBar}
                      onChange={(e) => this.handleChangeSingleBar('endDateSingleBar', e)}
                      maxDate={new Date()}
                      minDate={this.state.startDateSingleBar}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="DD/MM/YYYY"
                    />
                  </div>

                  <div className="col col-6 col-sm-4 col-lg-2"><br />
                    <Button color="primary   sub1" type="submit">Submit</Button>
                  </div>
                </div>
              </form>
            </div>
            <div className="col col-12 col-sm-12 col-lg-12">
              <div className="box-3rd card card101">
                <div className="bar-context row">
                  <div className=" pull-left col col-12 col-sm-12 col-lg-7"><h3 className="card-title"> AI Flow Experience</h3></div>
                  <div className=" col col-12 col-sm-12 col-lg-5">
                    {
                      this.state.notificationContextData &&
                      this.state.notificationContextData.length > 0 &&
                      <Form.Group label="Service" className="pull-right">
                        <Form.SelectGroup
                          canSelectMultiple
                          pills
                        >
                          {
                            this.state.notificationContextData.map((val, index) => {
                              return (
                                <Form.SelectGroupItem
                                  label={val.value}
                                  name={val.key}
                                  value="HTML"
                                  onClick={(e) => this.multiselectSingle(val.key)}
                                />
                              )
                            })
                          }


                        </Form.SelectGroup>
                      </Form.Group>
                    }

                  </div>
                </div>
                <div className="card-body p-3 text-center">
                  <C3Chart
                    data={this.getDataSingleBar()}

                    size={{
                      height: 440,

                    }}
                    bar={
                      {
                        width: 50
                      }
                    }
                    axis={this.getAxisLineBar()}
                    padding={{
                      bottom: 0,
                      top: 0,
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="box-al mar-40">
              <form onSubmit={this.handleSubmitSingleBarHorizontal}>
                <div className="row">
                  <div className="col col-6 col-sm-4 col-lg-5">
                    <label className="form-label">From Date</label>
                    <DatePicker
                      className="form-control"
                      selected={this.state.startDateSingleBarHorizontal}
                      onChange={(e) =>
                        this.handleChangeBarHorizontal(
                          "startDateSingleBarHorizontal",
                          e
                        )
                      }
                      maxDate={this.state.endDateSingleBarHorizontal}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="DD/MM/YYYY"
                      maxDate={new Date()}
                    />
                  </div>

                  <div className="col col-6 col-sm-4 col-lg-5">
                    <label className="form-label">To Date</label>
                    <DatePicker
                      className="form-control"
                      selected={this.state.endDateSingleBarHorizontal}
                      onChange={(e) =>
                        this.handleChangeBarHorizontal(
                          "endDateSingleBarHorizontal",
                          e
                        )
                      }
                      maxDate={new Date()}
                      minDate={this.state.startDateSingleBarHorizontal}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="DD/MM/YYYY"
                    />
                  </div>

                  <div className="col col-6 col-sm-4 col-lg-2">
                    <br />
                    <Button color="primary   sub1" type="submit">
                      Submit
                    </Button>
                  </div>

                  {/* <div className="col col-6 col-sm-4 col-lg-2">
                    <br />
                    <select name="" id="">
                      <option value=""></option>
                    </select>
                  </div> */}

                </div>
              </form>
            </div>
            <div className="col col-12 col-sm-12 col-lg-12">
              <div className="box-3rd card card101">
                <div className="bar-context row">
                  <div className=" pull-left col col-12 col-sm-12 col-lg-7">
                    <h3 className="card-title">Average Agent Rating</h3>
                  </div>
                </div>

                <div className="card-body p-3 text-center">
                  {/* <C3Chart
                                        data={this.getDataSingleBarHorizontal()}
                                       
                                        size={{
                                            height: 440,

                                        }}
                                        bar={
                                            {
                                                width: 50
                                            }
                                        }
                                        axis={this.getAxisLineBar()}
                                        padding={{
                                            bottom: 0,
                                            top: 0,
                                        }}
                                    /> */}

                  <C3Chart
                    // bindto ={{'#uv-div'}}
                    size={{
                      height: 500,
                    }}
                    bar={{
                      width: 50,
                    }}
                    padding={{
                      left: 100,
                      right: 100,
                    }}
                    // color= {{
                    //     pattern: ['#8a203e', '#ACB6DD']
                    // }}
                    data={this.getDataSingleBarHorizontal()}
                    axis={{
                      rotated: true,
                      x: {
                        type: "category",
                      },
                    }}
                    // tooltip= {{
                    //     grouped: false
                    // }}
                    legend={{
                      show: true,
                    }}
                  />
                </div>
                <div></div>
              </div>
              {/* <FeedBackAnalytics /> */}
            </div>

            {/* reportLogs  */}
            <div className="box-al mar-40">
              <form onSubmit={this.DataChangeReport}>
                <div className="row">
                  <div className="col col-6 col-sm-4 col-lg-5">
                    <label className="form-label">From Date</label>
                    <DatePicker
                      className="form-control"
                      selected={this.state.startDateForReportLogs}
                      onChange={(e) => this.handlerAllChatDateChanger("startDateForReportLogs", e)}
                      maxDate={this.state.endDateForReportLogs}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="DD/MM/YYYY"
                      maxDate={new Date()}
                    />
                  </div>

                  <div className="col col-6 col-sm-4 col-lg-5">
                    <label className="form-label">To Date</label>
                    <DatePicker
                      className="form-control"
                      selected={this.state.endDateForReportLogs}
                      onChange={(e) => this.handlerAllChatDateChanger("endDateForReportLogs", e)}
                      maxDate={new Date()}
                      minDate={this.state.startDateForReportLogs}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="DD/MM/YYYY"
                    />
                  </div>

                  <div className="col col-6 col-sm-4 col-lg-2">
                    <br />
                    <Button color="primary   sub1" type="submit">
                      Submit
                    </Button>
                  </div>
                </div>
              </form>
            </div>
            <div className="col col-12 col-sm-12 col-lg-12">
              <div className="box-3rd card card101">
                <div className="bar-context row">
                  <div className=" pull-left col col-12 col-sm-12 col-lg-7">
                    <h3 className="card-title"> Report Logs </h3>
                  </div>
                </div>
                <div className="card-body p-3 text-center">
                  <C3Chart
                    data={this.state.reportLogs}
                    // axis= {{
                    //     rotated: true,
                    //     x: {
                    //         type: 'category'
                    //     }
                    // }}
                    // tooltip= {{
                    //     grouped: false
                    // }}
                    legend={{
                      show: true
                    }}
                    donut={{
                      title: "Report Logs"
                    }}
                    tooltip={{
                      contents: this.tooltip_contentsForReportLogs
                    }}
                    colors={{
                      Success: '#ff0000',
                      Failure: '#00ff00',
                    }}
                  />

                </div>
                <div>
                </div>
              </div>
            </div>


            {/* reportLogs  */}
            <div className="box-al mar-40">
              <form onSubmit={this.DataChangeInvoice}>
                <div className="row">
                  <div className="col col-6 col-sm-4 col-lg-5">
                    <label className="form-label">From Date</label>
                    <DatePicker
                      className="form-control"
                      selected={this.state.startDateForInvoiceLogs}
                      onChange={(e) => this.handlerAllChatDateChanger("startDateForInvoiceLogs", e)}
                      maxDate={this.state.endDateForInvoiceLogs}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="DD/MM/YYYY"
                      maxDate={new Date()}
                    />
                  </div>

                  <div className="col col-6 col-sm-4 col-lg-5">
                    <label className="form-label">To Date</label>
                    <DatePicker
                      className="form-control"
                      selected={this.state.endDateForInvoiceLogs}
                      onChange={(e) => this.handlerAllChatDateChanger("endDateForInvoiceLogs", e)}
                      maxDate={new Date()}
                      minDate={this.state.startDateForInvoiceLogs}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="DD/MM/YYYY"
                    />
                  </div>

                  <div className="col col-6 col-sm-4 col-lg-2">
                    <br />
                    <Button color="primary   sub1" type="submit" >
                      Submit
                    </Button>
                  </div>
                </div>
              </form>
            </div>
            <div className="col col-12 col-sm-12 col-lg-12">
              <div className="box-3rd card card101">
                <div className="bar-context row">
                  <div className=" pull-left col col-12 col-sm-12 col-lg-7">
                    <h3 className="card-title"> Invoice Logs </h3>
                  </div>
                </div>
                <div className="card-body p-3 text-center">
                  <C3Chart
                    data={this.state.invoiceLogs}
                    // axis= {{
                    //     rotated: true,
                    //     x: {
                    //         type: 'category'
                    //     }
                    // }}
                    // tooltip= {{
                    //     grouped: false
                    // }}
                    le            // adminId = res.locals.userId,
                    gend={{
                      show: true
                    }}
                    donut={{
                      title: "Invoice Logs"
                    }}
                    tooltip={{
                      contents: this.tooltip_contentsForInvoiceLogs
                    }}
                    colors={{
                      Success: '#ff0000',
                      Failure: '#00ff00',
                    }}
                  />

                </div>
                <div>
                </div>
              </div>
            </div>



            {/* <div className="box-al mar-40">
              <form onSubmit={this.DataChangeForAnswerChatGraph}>
                <div className="row">
                  <div className="col col-6 col-sm-4 col-lg-3">
                    <label className="form-label">From Date</label>
                    <DatePicker className="form-control"
                      selected={this.state.startDateForAnswerChatGraph}
                      onChange={(e) => this.handlerAllChatDateChanger('startDateAnswerChatGraph', e)}
                      maxDate={this.state.endDateForAnswerChatGraph}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="DD/MM/YYYY"
                      maxDate={new Date()}
                    />
                  </div>

                  <div className="col col-6 col-sm-4 col-lg-3">
                    <label className="form-label">To Date</label>
                    <DatePicker className="form-control"
                      selected={this.state.endDateForAnswerChatGraph}
                      onChange={(e) => this.handlerAllChatDateChanger('endDateAnswerChatGraph', e)}
                      maxDate={new Date()}
                      minDate={this.state.startDateForAnswerChatGraph}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="DD/MM/YYYY"
                    />
                  </div>

                  <div className="col col-6 col-sm-4 col-lg-3">
                    <br />
                    <Button color="primary sub1">
                      Submit
                    </Button>
                  </div>

                  
                </div>
              </form>
            </div>
            <div className="col col-12 col-sm-12 col-lg-12">
              <div className="box-3rd card card101">
                <div className="bar-context row">
                  <div className=" pull-left col col-12 col-sm-12 col-lg-7">
                    <h3 className="card-title"> Time to answer </h3>
                  </div>
                </div>
                <div className="card-body p-3 text-center">
                  <C3Chart
                    size={{
                      height: 500
                    }}
                    
                    padding={{
                      left: 100,
                      right: 50
                    }}
                    
                    data={this.state.answerChatGraph}
                    
                    legend={{
                      show: true
                    }}
                    axis={this.getTimeToAnswerAxis()}
                  />

                </div>
                <div>
                </div>
              </div>
            </div> */}

            {/* Answer To graph */}
            {/* commented time to answer graph */}

            {/* <div className="box-al mar-40">
              <form onSubmit={this.DataChangeForAnswerChatGraph}>
                <div className="row">
                  <div className="col col-6 col-sm-4 col-lg-3">
                    <label className="form-label">From Date</label>
                    <DatePicker className="form-control"
                      selected={this.state.startDateForAnswerChatGraph}
                      onChange={(e) => this.handlerAllChatDateChanger('startDateAnswerChatGraph', e)}
                      maxDate={this.state.endDateForAnswerChatGraph}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="DD/MM/YYYY"
                      maxDate={new Date()}
                    />
                  </div>

                  <div className="col col-6 col-sm-4 col-lg-3">
                    <label className="form-label">To Date</label>
                    <DatePicker className="form-control"
                      selected={this.state.endDateForAnswerChatGraph}
                      onChange={(e) => this.handlerAllChatDateChanger('endDateAnswerChatGraph', e)}
                      maxDate={new Date()}
                      minDate={this.state.startDateForAnswerChatGraph}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="DD/MM/YYYY"
                    />
                  </div>

                  <div className="col col-6 col-sm-4 col-lg-3">
                    <br />
                    <Button color="primary sub1">
                      Submit
                    </Button>
                  </div> */}

            {/* <div className="col col-6 col-sm-4 col-lg-3">
                          <label className="form-label">Agents</label>
                          <Form.Select name={this.state.chatAgent}
                            onChange={(e) => this.changeAgentChat(e)}>
                              <option value=''>                           
                                  All Agent
                              </option>
                              <option value='junior'>
                                  junior 
                              </option>
                              <option value='senior'>
                                  senior
                              </option>
                          </Form.Select>                            
                        </div> */}
            {/* </div>
              </form>
            </div> */}
            {/* <div className="col col-12 col-sm-12 col-lg-12">
              <div className="box-3rd card card101">
                <div className="bar-context row">
                  <div className=" pull-left col col-12 col-sm-12 col-lg-7">
                    <h3 className="card-title"> Time to answer </h3>
                  </div>
                </div>
                <div className="card-body p-3 text-center">
                  <C3Chart
                    size={{
                      height: 500
                    }}
                    bar= {{
                        width: 50
                    }}
                    padding={{
                      left: 100,
                      right: 50
                    }}
                    color= {{
                        pattern: ['#8a203e', '#ACB6DD']
                    }}
                    data={this.state.answerChatGraph}
                    axis= {{
                        rotated: true,
                        x: {
                            type: 'category'
                        }
                    }}
                    tooltip= {{
                        grouped: false
                    }}
                    legend={{
                      show: true
                    }}
                    axis={this.getTimeToAnswerAxis()}
                  />

                </div>
                <div>
                </div>
              </div>
              <FeedBackAnalytics />
            </div> */}



          </Grid.Row>
          <DownloadPopup
            openInfoPopup={this.state.openDownloadPopup}
            onChange={this.closeDownloadPopup}
          ></DownloadPopup>
          <FeedbackDownloadPopup
            openInfoPopup={this.state.feedbackDownloadPopup}
            onChange={() => this.closeFeedbackDownloadPopup()}
          ></FeedbackDownloadPopup>
        </Page.Content>
      </SiteWrapperSuperAdmin>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    activeBot: state.auth.activeBot,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    logOut: () => {
      dispatch(authActions.authLogout());
    },
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Analytic)
);
